module.exports = __webpack_public_path__ + "img/ticket-003.ff28f3d7.svg";